import { create } from "zustand";

interface NotificationState {
  visible: boolean;
  type: "processing" | "success" | "error";
  title: string;
  message: string;
}

interface NotificationActions {
  showNotification: (
    type: "processing" | "success" | "error",
    title: string,
    message: string,
    duration?: number | null // null means persistent (no auto-hide)
  ) => void;
  hideNotification: () => void;
}

type NotificationStore = NotificationState & NotificationActions;

let autoHideTimer: ReturnType<typeof setTimeout> | null = null;

export const useNotificationStore = create<NotificationStore>((set) => ({
  visible: false,
  type: "processing",
  title: "",
  message: "",

  showNotification: (type, title, message, duration = 5000) => {
    // Clear any existing timer
    if (autoHideTimer) {
      clearTimeout(autoHideTimer);
      autoHideTimer = null;
    }

    set({ visible: true, type, title, message });

    // If duration is provided (not null), auto-hide after that duration
    if (duration !== null && duration > 0) {
      autoHideTimer = setTimeout(() => {
        set({ visible: false });
        autoHideTimer = null;
      }, duration);
    }
  },

  hideNotification: () => {
    if (autoHideTimer) {
      clearTimeout(autoHideTimer);
      autoHideTimer = null;
    }
    set({ visible: false, type: "processing", title: "", message: "" });
  },
}));

